import { useCallback } from 'react'
import { useLazyQuery } from '@apollo/client'

import { useCache } from '~/shared/hooks'
import { QUERY_ENGAGE_ACCOUNT } from '~/modules/account/queries'

/**
 *
 */
export default function useEngageAccount() {
  const { getData, setData } = useCache()

  const [queryEngageAccount, { data, error, loading, refetch }] =
    useLazyQuery(QUERY_ENGAGE_ACCOUNT)

  const getEngageAccount = useCallback(
    (organizationId: any) => {
      const result = getData({
        query: QUERY_ENGAGE_ACCOUNT,
        variables: { organizationId },
      })

      return result ? result.engageOrganization : null
    },
    [getData],
  )

  const setEngageAccount = useCallback(
    (organizationId: any, engageAccount: any) => {
      setData({
        query: QUERY_ENGAGE_ACCOUNT,
        variables: { organizationId },
        data: {
          engageOrganization: engageAccount,
        },
      })
    },
    [setData],
  )

  return {
    engageAccount: data ? data.engageOrganization : null,
    getEngageAccount,
    setEngageAccount,
    queryEngageAccount,
    queryEngageAccountStatus: { loading, error },
    refetchEngageAccount: refetch,
  }
}
